import combinedAssetsListFromLib from '@exodus/combined-assets-meta';
import ethereum from './ethereum.js';
import { dynamicEvmChains } from '../dynamic-evms/index.js';
// Filter the combined assets list to only include multi-network assets.
export const combinedAssetsList = [
    ...combinedAssetsListFromLib,
    ...ethereum,
].filter((asset) => asset.assetType === 'MULTI_NETWORK_ASSET');
// Add "Dynamic EVM" chain names to the combined asset names where applicable.
// NOTE: The arrays are small so the performance impact of this nested loop is negligible.
combinedAssetsList.forEach(({ name, combinedAssetNames }) => {
    dynamicEvmChains.forEach(({ assetPlugin, combinedAssetName }) => {
        if (combinedAssetName === name) {
            combinedAssetNames?.push(assetPlugin.name);
        }
    });
});
